var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ScrollupSection'),_c('div',{staticClass:"all-area"},[_c('HeaderSection'),_c('BreadcrumbSection'),_c('FaqSection'),_c('NewsletterSection'),_c('FooterSection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }